/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IOrderTemplateNameDialogResources, OrderTemplateNameDialog } from '@msdyn365-commerce/components';
import { IComponentProps } from '@msdyn365-commerce/core';
import React, { useState } from 'react';

const modalCloseButtonReference: React.RefObject<HTMLButtonElement> = React.createRef();

/**
 * The Create Order Template Button Props.
 */
export interface ICreateOrderTemplateButtonProps extends IComponentProps {
    /**
     * The label for create order template.
     */
    createOrderTemplateText: string;

    /**
     * The create order template dialog resources.
     */
    createOrderTemplateDialogResources: IOrderTemplateNameDialogResources;

    /**
     * The delegate to fire when dialog captured any user entry.
     */
    onOrderTemplateCreated(): Promise<void>;
}

const CreateOrderTemplateButton: React.FC<ICreateOrderTemplateButtonProps> = props => {
    const onCancelHandler = React.useCallback(() => {
        return;
    }, []);
    const [isCreateOrderTemplateDialogOpen, setOrderTemplateNameDialogOpen] = useState(false);
    const onCreateButtonClick = React.useCallback(() => {
        setOrderTemplateNameDialogOpen(true);
    }, []);

    return (
        <>
            <button
                className='ms-order-template__add-template-button msc-btn btn-primary'
                color='primary'
                onClick={onCreateButtonClick}
                ref={modalCloseButtonReference}
                aria-label={props.createOrderTemplateText}
            >
                {props.createOrderTemplateText}
            </button>
            <OrderTemplateNameDialog
                className='msc-order-template-name-dialog'
                modalOpen={isCreateOrderTemplateDialogOpen}
                isUpdateDialog={false}
                setModalOpen={setOrderTemplateNameDialogOpen}
                context={props.context}
                id={props.id}
                data={{}}
                typeName={props.typeName}
                dialogStrings={props.createOrderTemplateDialogResources}
                onCancel={onCancelHandler}
                onSuccess={props.onOrderTemplateCreated}
                parentElementRef={modalCloseButtonReference}
            />
        </>
    );
};

export default CreateOrderTemplateButton;
